import { useEffect } from 'react'
import { shellCopy } from '@/copy/shell'

/** accessibility: route changes update the document title (D88). */
export function useDocumentTitle(page: string) {
  useEffect(() => {
    document.title = shellCopy.documentTitle(page)
    return () => {
      document.title = shellCopy.documentTitle('')
    }
  }, [page])
}
